import { PatientOverviewAverageType } from '~/services/api/enums';

export const intervalNames = {
  [PatientOverviewAverageType.Weekly]: 'Week',
  [PatientOverviewAverageType.Monthly]: 'Month',
};

export default {};
